module.exports = __webpack_public_path__ + "img/logo-wandr_e-compact-white.c367a655.svg";